import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './Header.module.scss'
import { Modal } from 'almanac-ui/Modal'

export const Header = ({ onBack, children }: { onBack?: () => void; children: React.ReactNode }) => {
  const { isMobile } = useResponsiveDesign()

  if (isMobile) return null

  return (
    <div className={Styles.heading}>
      <Modal.BackButton onPress={onBack} />

      <div className={Styles.title}>{children}</div>
      <div className={Styles.spacer} />
    </div>
  )
}
